import React from 'react';
import ReactDOM from 'react-dom';
import './css/myfonts.css';
import './css/screen3.css';

//import './js/retina.min.js';
//import './js/jquery.matchHeight';
//import './js/jquery.call.js';

import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';

import App from './App';
import reducers from './reducers';
//import registerServiceWorker from './registerServiceWorker';
import TagManager from 'react-gtm-module'
 
import { unregister as unregisterServiceWorker } from './registerServiceWorker'

const tagManagerArgs = {
    gtmId: 'GTM-KTBC27H'
}
 
TagManager.initialize(tagManagerArgs)

//window.$ = window.jQuery = require("jquery");

const loggerMiddleware = createLogger();

const store = createStore(reducers,
    applyMiddleware(
        thunkMiddleware,
        loggerMiddleware
    )
);

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
);

//registerServiceWorker();
unregisterServiceWorker();




// WEBPACK FOOTER //
// ./src/index.js